export type DisplayProfileId = "1080p" | "1440p" | "1800p" | "2160p";

export interface DisplayProfile {
  id: DisplayProfileId;
  label: string;
  width: number;
  height: number;
  minimumFontSize: {
    body: number;
    small: number;
  };
}

export const DISPLAY_PROFILES: readonly DisplayProfile[] = [
  { id: "1080p", label: "1080P", width: 1920, height: 1080, minimumFontSize: { body: 18, small: 14 } },
  { id: "1440p", label: "2K", width: 2560, height: 1440, minimumFontSize: { body: 18, small: 14 } },
  { id: "1800p", label: "3K", width: 3200, height: 1800, minimumFontSize: { body: 18, small: 14 } },
  { id: "2160p", label: "4K", width: 3840, height: 2160, minimumFontSize: { body: 18, small: 14 } }
];

export const DEFAULT_DISPLAY_PROFILE = DISPLAY_PROFILES[DISPLAY_PROFILES.length - 1];
